import { render, staticRenderFns } from "./QuoteOrm.vue?vue&type=template&id=3ba7453b&scoped=true"
import script from "./QuoteOrm.vue?vue&type=script&lang=js"
export * from "./QuoteOrm.vue?vue&type=script&lang=js"
import style0 from "./QuoteOrm.vue?vue&type=style&index=0&id=3ba7453b&lang=scss&scoped=true"
import style1 from "./QuoteOrm.vue?vue&type=style&index=1&id=3ba7453b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7453b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ba7453b')) {
      api.createRecord('3ba7453b', component.options)
    } else {
      api.reload('3ba7453b', component.options)
    }
    module.hot.accept("./QuoteOrm.vue?vue&type=template&id=3ba7453b&scoped=true", function () {
      api.rerender('3ba7453b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteOrm.vue"
export default component.exports